<body class="ltr main-body leftmenu">
  <div class="main-content side-content pt-0 ml-0">
    <div class="main-container container-fluid">
      <div class="inner-body">
        <div class="row row-sm add-form">
          <form autocomplete="off" class="p-0" novalidate [formGroup]="reportForm">
            <div class="col-lg-12 col-md-12">
              <div class="card custom-card">
                <div class="card-body">
                  <!-- Header -->
                  <div class="row">
                    <div class="col-sm-9">
                      <div class="d-flex align-items-center pl-3">
                        <img alt="Logo" src="../../assets/img/purse.png" class="mh-45px pb-2" />
                        <div class="ml-2">
                          <h3 class="main-content-label mb-1"><b>Student Summary Report</b></h3>
                          <p class="text-muted card-sub-title mb-0">Generate Student Summary Report</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="row clearfix mt-2">
                    <div class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="w-100" style="font-size: 12px;">
                          <mat-label style="font-size: 12px;">Session</mat-label>
                          <mat-select
                            #select232
                            placeholder="Session"
                            class="colorblack"
                            formControlName="SessionId"
                            style="font-size: 12px;"
                          >
                            <mat-select-filter
                              *ngIf="select232.focused"
                              [placeholder]="'Filter'"
                              [displayMember]="'SnName'"
                              [array]="sessionList"
                              (filteredReturn)="SessionFilterList = $event"
                            ></mat-select-filter>
                            <mat-option
                              *ngFor="let item of SessionFilterList"
                              [value]="item.SnNo"
                              style="font-size: 12px;"
                            >
                              {{ item.SnNo }} - {{ item.SnName }}
                            </mat-option>
                          </mat-select>
                          <!-- <mat-error
                            *ngIf="reportForm.get('SessionId').hasError('required') && reportForm.get('SessionId').touched"
                            style="font-size: 11px;"
                          >
                            Session is required
                          </mat-error> -->
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="w-100" style="font-size: 12px;">
                          <mat-label style="font-size: 12px;">College *</mat-label>
                          <mat-select
                            formControlName="college"
                            multiple
                            (selectionChange)="onCollegeSelect($event)"
                            style="font-size: 12px;"
                          >
                            <mat-select-filter
                              *ngIf="true"
                              [placeholder]="'Search College...'"
                              [displayMember]="'CgName'"
                              [array]="collegeList"
                              (filteredReturn)="filteredCollegeList = $event"
                            ></mat-select-filter>
                            <mat-option
                              (click)="selectAllColleges()"
                              [value]="'selectAll'"
                              [checked]="isAllSelected()"
                              style="font-size: 12px;"
                            >
                              <strong>Select All</strong>
                            </mat-option>
                            <mat-option
                              *ngFor="let item of filteredCollegeList"
                              [value]="item.CgCode"
                              [checked]="selectedColleges.includes(item.CgCode)"
                              style="font-size: 12px;"
                            >
                              {{ item.CgCode }} - {{ item.CgName }}
                            </mat-option>
                          </mat-select>
                          <mat-error
                            *ngIf="reportForm.get('college').hasError('required') && reportForm.get('college').touched"
                            style="font-size: 11px;"
                          >
                            College is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="w-100" style="font-size: 12px;">
                          <mat-label>From Date</mat-label>
                          <input 
                            matInput 
                            [matDatepicker]="fromPicker" 
                            formControlName="fromDate" 
                            placeholder="dd/mm/yyyy"
                            (dateChange)="updateDownloadButtonVisibility()"
                          >
                          <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                          <mat-datepicker #fromPicker></mat-datepicker>
                        </mat-form-field>
                        <!-- Error message below the input field -->
                        <div *ngIf="reportForm.get('fromDate').touched && reportForm.hasError('fromDateGreater')" class="text-danger" style="font-size: 11px; margin-top: -10px; margin-bottom: 5px;">
                          <i class="fas fa-exclamation-circle mr-1"></i>
                          From Date cannot be greater than To Date
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="w-100" style="font-size: 12px;">
                          <mat-label>To Date</mat-label>
                          <input 
                            matInput 
                            [matDatepicker]="toPicker" 
                            formControlName="toDate" 
                            placeholder="dd/mm/yyyy"
                            (dateChange)="updateDownloadButtonVisibility()"
                          >
                          <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                          <mat-datepicker #toPicker></mat-datepicker>
                        </mat-form-field>
                        <!-- Error message below the input field -->
                        <div *ngIf="reportForm.get('toDate').touched && reportForm.hasError('toDateLess')" class="text-danger" style="font-size: 11px; margin-top: -10px; margin-bottom: 5px;">
                          <i class="fas fa-exclamation-circle mr-1"></i>
                          To Date cannot be less than From Date
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row clearfix mt-3">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="d-block mb-1" style="font-weight: 500; font-size: 15px;">Report Type</label>
                        <mat-radio-group 
                          formControlName="reportType" 
                          class="d-flex align-items-center" 
                          style="font-size: 15px;"
                        >
                          <mat-radio-button value="CLG" class="mr-4">As College</mat-radio-button>
                          <mat-radio-button value="CENT">As Center</mat-radio-button>
                        </mat-radio-group>
                        <div class="mt-2 p-2 bg-light border-left border-primary" style="border-left-width: 4px !important;">
                          <small class="text-muted" style="font-size: 15px;">
                            <strong>Note:</strong> Affects only Collegewise Student Name Report
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="row justify-content-center mt-4" *ngIf="showCollegewiseButton || showCenterwiseButton">
                    <div class="col-lg-5 col-md-6 col-sm-12 text-center mb-3" *ngIf="showCollegewiseButton">
                      <div class="card card-success h-100">
                        <div class="card-body d-flex flex-column align-items-center justify-content-center">
                          <div class="btn-group w-100" role="group">
                            <button
                              type="button"
                              class="btn btn-primary btn-lg w-100 py-3"
                              style="font-size: 1.0rem; font-weight: 600; letter-spacing: 0.5px;"
                              (click)="downloadCollegewiseReport()"
                              [disabled]="isDownloading"
                            >
                              <span *ngIf="!isDownloading">
                                <i class="fas fa-download mr-3" style="font-size: 1.4rem;"></i>
                                Collegewise Student Name Report
                              </span>
                              <span *ngIf="isDownloading">
                                <i class="fas fa-spinner fa-spin mr-3" style="font-size: 1.4rem;"></i>
                                Downloading...
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-5 col-md-6 col-sm-12 text-center mb-3" *ngIf="showCenterwiseButton">
                      <div class="card card-success h-100">
                        <div class="card-body d-flex flex-column align-items-center justify-content-center">
                          <div class="btn-group w-100" role="group">
                            <button
                              type="button"
                              class="btn btn-primary btn-lg w-100 py-3"
                              style="font-size: 1.0rem; font-weight: 600; letter-spacing: 0.5px;"
                              (click)="downloadCenterwiseReport()"
                              [disabled]="isDownloading || !isDateRangeValid()"
                            >
                              <span *ngIf="!isDownloading">
                                <i class="fas fa-download mr-3" style="font-size: 1.4rem;"></i>
                                Centerwise Student Seat Summary Report
                              </span>
                              <span *ngIf="isDownloading">
                                <i class="fas fa-spinner fa-spin mr-3" style="font-size: 1.4rem;"></i>
                                Downloading...
                              </span>
                            </button>
                          </div>
                          <small *ngIf="!isDateRangeValid() && reportForm.get('fromDate').value && reportForm.get('toDate').value" class="text-danger mt-1" style="font-size: 11px;">
                            <i class="fas fa-exclamation-circle mr-1"></i>
                            Invalid date range
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</body>